import React from 'react';

import { Species } from '../../api/fishrules/getSpeciesAtLocation';
import { Pill } from '../Clickables/Pill/Pill';
import { Heading } from '../Heading/Heading';
import { Modal } from '../Modal/Modal';
import { ModalBody } from '../Modal/ModalBody';
import { Text } from '../Text/Text';

import { getRestrictionsAndRequirements } from './helpers';

interface IProps {
  species: Species;
}

export const ProhibitedMethods = ({ species }: IProps) => {
  const restrictionsAndRequirements = getRestrictionsAndRequirements(species);

  return (
    <>
      {restrictionsAndRequirements.map(({ name, label, description }) => (
        <Modal
          key={name}
          trigger={props => (
            <Pill {...props} variant="error" className="mr-2 mt-2 inline">
              {label}
            </Pill>
          )}
        >
          <ModalBody>
            <Heading variant="sm" className="mb-4">
              {label}
            </Heading>
            <Text className="mb-0">{description}</Text>
          </ModalBody>
        </Modal>
      ))}
    </>
  );
};
